import { Injectable } from '@angular/core';
import {RequesterService} from "../../shared/services/requester/requester.service";
import {BehaviorSubject} from "rxjs";
import {DbResponse} from "../../shared/interceptors/db-response";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../store";
import * as fromStore from '../../store';
import {Utils} from "../../shared/utils/utils";
import {map} from "rxjs/operators";
import {CookieService} from "ngx-cookie";
import {ReCaptchaV3Service} from "ngx-captcha";

@Injectable({
  providedIn: 'root'
})
export class AiAssistantService {

  private ownerWorkspaceId: any;
  private currentWorkspaceId: any;

  constructor(
    private _requester: RequesterService,
    private _store: Store<DbStoreState>,
    private _cookieService: CookieService,
    private _reCaptchaV3Service:ReCaptchaV3Service
  ) {
    this._getWorkspaceEntities();
  }

  private _getWorkspaceEntities(): void {
    this._store
      .select(fromStore.getWorkspaceIdEntities)
      .subscribe(workspaceIdEntities => {
        this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
        this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
      });
  }

  public getCategories(isEcommerceType: boolean = false, hasEcommerceService = true): BehaviorSubject<DbResponse> {
    const routeUrl = `proxy/generative/categories?website_type=` + (isEcommerceType ? `ecommerce` : `basic`);

    return <BehaviorSubject<DbResponse>>(this._requester.aiAssistant.get(routeUrl, false)
      .pipe(map((response: DbResponse) => {
        if (response && response.success && response.data) {
          response.data = Utils.shuffleArray(response.data);
        }
        return response;
      })));
  }

  public generateBusinessNames(description, industry, captcha_response, short_flow = false) {
    const _data: any = {description, industry, captcha_response};
    if (short_flow === true) {
      Object.assign(_data, {short_flow});
    }
    return this._requester.miniProducts
      .post(`ai_mini_products/business_name_score`, null, _data);
  }

  public generateSlogan(input, type, captcha_response, short_flow = false) {
    const _data: any = {input, captcha_response};
    if (type) {
      Object.assign(_data, {type});
    }
    if (short_flow === true) {
      Object.assign(_data, {short_flow});
    }
    return this._requester.miniProducts
      .post(`ai_mini_products/slogan_generator`, null, _data);
  }

  public generateHeroSectionTexts(input, industry, captcha_response) {
    const _data: any = {input, captcha_response};
    if (industry) {
      Object.assign(_data, {industry});
    }
    return this._requester.miniProducts
      .post(`ai_mini_products/hero_section`, null, _data);
  }

  public generateBrandKitToken(data) {
    return this._requester.miniTools
      .post(`generate_brand_kit`, null, data);
  }

  public generateSlogans(data) {
    return this._requester.miniTools
      .post(`generate_slogans`, null, data);
  }

  public generateVisions(data) {
    return this._requester.miniTools
      .post(`generate_vision`, null, data);
  }

  public generateMissions(data) {
    return this._requester.miniTools
      .post(`generate_mission`, null, data);
  }

  public generateLogos(business_name: string, industry: string, input: string, captcha_response: string, n_images: number = 1, n_logos: number = 3, ) {
    const _data: any = {business_name, input, captcha_response, n_images, n_logos};
    if (industry) {
      Object.assign(_data, {industry});
    }
    return this._requester.miniProducts
      .post(`ai_mini_products/generate_image`, null, _data);
  }


  public getTemplateQuestions(category: string, isEcommerce: boolean = false, fromLandingPage: boolean = false): BehaviorSubject<DbResponse> {
    const params =  {category};
    const getExperimentalCookie = this._cookieService.get('db-experiment');
    const templateSelectionModeCookie = getExperimentalCookie && JSON.parse(getExperimentalCookie) && JSON.parse(getExperimentalCookie).templateSelectionMode;
    const templateSelectionMode = templateSelectionModeCookie || 'usability';
    const routeUrl = `proxy/generative/templates/questions?template_selection=${templateSelectionMode}`;
    return this._requester.aiAssistant.get(routeUrl, params, true);
  }
}
